import { gql } from '@apollo/client';

export default gql`
  mutation editInspection(
    $id: ID!
    $inspectionSubjectId: ID
    $name: String!
    $periodCycle: String!
    $periodNumber: Int!
    $dueDate: ISO8601DateTime!
    $notes: String
    $inspectorId: ID
    $inspectionFields: [InspectionFieldInput!]
  ) {
    editInspection(
      input: {
        id: $id
        inspectionSubjectId: $inspectionSubjectId
        name: $name
        periodCycle: $periodCycle
        periodNumber: $periodNumber
        dueDate: $dueDate
        notes: $notes
        inspectorId: $inspectorId
        inspectionFields: $inspectionFields
      }
    ) {
      inspection {
        id
        name
      }
    }
  }
`;
